import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from '../../components/ui/Logo';
import './About.css';

const About = () => {
  const pillars = [
    {
      icon: '🔍',
      title: 'Claridad antes de construir',
      description: 'Validamos la visión, los usuarios y el alcance antes de escribir código.'
    },
    {
      icon: '🏗️',
      title: 'Arquitectura moderna y escalable',
      description: 'Diseñamos soluciones sobre cloud, serverless y prácticas de ingeniería actuales.'
    },
    {
      icon: '🤖',
      title: 'Tecnología inteligente',
      description: 'Integramos IA donde aporta valor real para acelerar procesos y decisiones.'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero__content">
            <motion.div
              className="about-hero__text"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1 className="about-hero__title">
                Somos <span className="gradient-text">DUIT</span>: diseño, tecnología e inteligencia trabajando juntos
              </h1>
              <p className="about-hero__description">
                Ayudamos a empresas a transformar ideas en productos digitales claros, sólidos y listos para crecer, combinando estrategia, arquitectura cloud e inteligencia artificial.
              </p>
            </motion.div>
            
            <motion.div
              className="about-hero__visual"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <div className="about-hero__logo-container">
                <Logo width={280} className="about-hero__logo" />
                <div className="about-hero__logo-glow"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="about-philosophy">
        <div className="container">
          <motion.div
            className="about-philosophy__content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <p className="about-philosophy__text">
              En DUIT creemos que un buen producto digital no surge por accidente: se diseña con claridad, se valida con inteligencia y se construye sobre bases técnicas sólidas. Por eso combinamos <strong>estrategia de producto</strong>, <strong>arquitectura en la nube</strong> y <strong>automatización con IA</strong> en un modelo único que reduce riesgos, acelera el desarrollo y garantiza resultados reales.
            </p>
            
            <div className="about-philosophy__statements">
              <p>No somos una agencia creativa.</p>
              <p>No somos una software factory.</p>
              <p>No somos una consultora tradicional.</p>
            </div>
            
            <p className="about-philosophy__conclusion">
              Somos un equipo híbrido que integra <strong>diseño, ingeniería y tecnología inteligente</strong> para acompañarte desde el primer boceto hasta la puesta en producción.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Pillars Section */}
      <section className="about-pillars">
        <div className="container">
          <motion.div
            className="about-pillars__header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="about-pillars__title">Nuestros pilares</h2>
          </motion.div>

          <div className="about-pillars__grid">
            {pillars.map((pillar, index) => (
              <motion.div
                key={index}
                className="about-pillar-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="about-pillar-card__icon">{pillar.icon}</div>
                <h3 className="about-pillar-card__title">{pillar.title}</h3>
                <p className="about-pillar-card__description">{pillar.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <motion.div
            className="about-cta__content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="about-cta__title">¿Quieres conocer más sobre nuestro enfoque?</h2>
            <div className="about-cta__actions">
              <Link to="/metodologia" className="btn btn--primary btn--large">
                Conoce nuestra metodología
              </Link>
              <Link to="/contacto" className="btn btn--secondary btn--large">
                Agenda una llamada
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
